/**
 * 通用方法函数
 */

/**
 * 判断两个对象是否相等，这两个对象的值只能是数字或字符串
 * @param { object } obj1 对象
 * @param { object } obj2 对象
 */
export const objEqual = (obj1, obj2) => {
	const keysArr1 = Object.keys(obj1);
	const keysArr2 = Object.keys(obj2);
	if (keysArr1.length !== keysArr2.length) {
		return false;
	} else if (keysArr1.length === 0 && keysArr2.length === 0) {
		return true;
	} else {
		/* eslint-disable-next-line */
		return !keysArr1.some(key => obj1[key] != obj2[key]);
	}
};

/**
 * @param {Number} times 回调函数需要执行的次数
 * @param {Function} callback 回调函数
 */
export const doTimes = (times, callback) => {
	let i = -1;
	while (++i < times) {
		callback(i);
	}
};

/**
 * 数组去重
 * @param { array } arr 需要去重的数组
 * @returns { array }
 */
export function uniqueArr(arr) {
	return Array.from(new Set(arr));
}

/**
 * 从URL中解析参数
 * @param { string } url
 * @returns { object }
 */
export const queryString = url => {
	let params = {};
	const arr = url.split('?');
	if (arr.length > 1 && arr[1]) {
		const queryParams = arr[1].split('&');
		queryParams.forEach(item => {
			const keyValue = item.split('=');
			params[keyValue[0]] = keyValue[1];
		});
	}
	return params;
};

/**
 * 判断时间戳格式是否是毫秒
 * @param { int } timeStamp
 * @returns {Boolean}
 */
export const isMillisecond = timeStamp => {
	const timeStr = String(timeStamp);
	return timeStr.length > 10;
};

/**
 * 如果传入的数值小于10，即位数只有1位，则在前面补充0
 * @param { number } num 数值
 * @returns { string } 处理后的字符串
 */
export const HandleNumber = num => {
	return num < 10 ? '0' + num : num;
};

/**
 * @returns {String} 当前浏览器名称
 */
export const getExplorer = () => {
	const ua = window.navigator.userAgent;
	const isExplorer = exp => {
		return ua.indexOf(exp) > -1;
	};
	if (isExplorer('MSIE')) {
		return 'IE';
	} else if (isExplorer('Firefox')) {
		return 'Firefox';
	} else if (isExplorer('Chrome')) {
		return 'Chrome';
	} else if (isExplorer('Opera')) {
		return 'Opera';
	} else if (isExplorer('Safari')) {
		return 'Safari';
	}
};

/**
 * 函数防抖
 * @param { function } func 传入需要延时的函数
 * @param { int } delay 延时ms
 */

export function debounce(func, delay) {
	let timer = null;
	return function() {
		let self = this,
			args = arguments;
		console.log(args);
		timer && clearTimeout(timer);
		timer = setTimeout(function() {
			func.apply(self, args);
		}, delay);
	};
}
/**
 * 函数节流
 * @param { function } func 执行的回调函数
 * @param { int } wait 等待时间
 * @param { object } options 执行方式 options.leading 表示首次触发是否执行 options.trailing表示超过规定时间是否仍然要触发。 注意leading和trailing不能同时设置。
 * @returns { function }
 */
export function throttle(func, wait) {
	let context, args;
	let previous = 0;

	return function() {
		let now = +new Date();
		context = this;
		args = arguments;
		if (now - previous > wait) {
			func.apply(context, args);
			previous = now;
		}
	};
}

/**
 * 获取指定范围【min, max】的随机整数
 * @param { int } min
 * @param { int } max
 * @returns { int }
 */
export function random(min, max) {
	return Math.floor(Math.random() * (max - min)) + min;
}

/**
 * 解码base64
 * @param { string } str
 * @returns { string }
 */
export function base64DecodeUnicode(str) {
	return decodeURIComponent(
		atob(str)
			.split('')
			.map(function(c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			})
			.join('')
	);
}

/**
 * 判断字符串是否从首字符串开始
 * @param { string } str 完整的字符串
 * @param { string } prefix 指定字符串
 * @returns { boolean }
 */
export function startsWith(str, prefix) {
	return str.slice(0, prefix.length) === prefix;
}
/**
 * base64 转换 blod
 * @param { string } base64Str base64字符串、
 */
export function URLtoBlob(base64Str) {
	var arr = base64Str.split(','),
		mime = arr[0].match(/:(.*?);/)[1],
		bstr = atob(arr[1]),
		n = bstr.length,
		u8arr = new Uint8Array(n);
	while (n--) {
		u8arr[n] = bstr.charCodeAt(n);
	}
	return new Blob([u8arr], { type: mime });
}
/**
 * 判断是否大于0的正整数
 * @param { string } value 完整的字符串
 * @returns { boolean }
 */
export function greaterThan(value) {
	let greaterthan = /^([1-9]\d*|[1]{1,1})$/;
	return !greaterthan.test(value);
}

/**
 * 判断是否为大于0且小于9999.9的金额，且最多保留1位小数
 * @param { string } value 完整的字符串
 * @returns { boolean }
 */
export function decimalPositive(value) {
	let decimalpositive = /^([1-9]\d{0,3}\.\d|0\.\d|[1-9][0-9]{0,3})$/;
	return !decimalpositive.test(value);
}
